<template>
  <div>
    <DialogBase
      title="Điều khoản sử dụng"
      :visible.sync="isTermsOfUseDialog"
      width="650px"
      panel-icon="el-icon-document"
      panel-title="XÁC NHẬN CHẤP THUẬN ĐIỀU KHOẢN BẢO MẬT"
      panel-subtitle="Quý Khách hàng vui lòng xác nhận sự đồng thuận về bảo vệ dữ liệu cá nhân theo Nghị định số 13/2023/NĐ-CP."
      confirm-text="Có, tôi đồng ý"
      cancel-text="Không đồng ý"
      @before-close="handleClose"
      @cancel="handleClose"
      @confirm="handleAgree"
    >
      <div class="dialog-inner-body">
        <p class="paragraph-text">
          Quý Khách hàng hiện đang sử dụng dịch vụ nhận thông báo biến động số dư tài khoản ngân hàng được tích hợp trong phần mềm
          <strong>OneKids</strong>, do đối tác trung gian của OneKids cung cấp.
        </p>
        
        <p class="paragraph-text">
          Căn cứ quy định tại <strong>Nghị định số 13/2023/NĐ-CP</strong> về bảo vệ dữ liệu cá nhân, nhằm đảm bảo việc tuân thủ quy định pháp luật liên quan đến bảo mật thông tin,
          <strong>OneKids</strong> xin xác nhận sự đồng thuận từ Quý Khách hàng đối với các nội dung sau trước khi sử dụng dịch vụ, cụ thể:
        </p>

        <!-- Terms list panel -->
        <div class="terms-list-box mb-3">
          <ol class="terms-ordered-list">
            <li>
              Tôi đồng ý cho phép <strong>OneKids</strong>, thông qua đối tác được ủy quyền, cung cấp và chia sẻ thông tin cần thiết với ngân hàng nơi tôi đang sử dụng tài khoản,
              nhằm mục đích đăng ký và kích hoạt dịch vụ nhận thông báo biến động số dư.
            </li>
            <li>
              Tôi đồng ý cho phép <strong>OneKids</strong> và đối tác trung gian tiếp nhận dữ liệu giao dịch phát sinh từ tài khoản ngân hàng của tôi,
              giới hạn trong phạm vi hiển thị thông tin trên phần mềm OneKids phục vụ mục đích quản lý thanh toán.
            </li>
            <li>
              Tôi xác nhận đã đọc, hiểu rõ và đồng ý để ngân hàng cung cấp thông tin liên quan đến trạng thái giao dịch của tài khoản cho đối tác trung gian và <strong>OneKids</strong>.
              Đồng thời, tôi chấp thuận với 
              <a href="https://onekids.edu.vn/bdsd_dieu_khoan" target="_blank" class="terms-link">
                toàn bộ điều kiện và điều khoản sử dụng dịch vụ
              </a>.
            </li>
          </ol>
        </div>

        <p class="warning-alert-text">
          * Bằng việc nhấn vào nút “Có, tôi đồng ý” bên dưới, Quý Khách hàng xác nhận đã hiểu rõ, đồng ý và chấp thuận toàn bộ nội dung nêu trên.
        </p>
      </div>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";

export default {
  name: "TermsOfUseDialogVersion2",
  components: { DialogBase },
  props: {
    isTermsOfUseDialog: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },
    handleAgree() {
      this.$emit("agree");
    }
  }
};
</script>

<style lang="scss" scoped>
.paragraph-text {
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
  margin-bottom: 12px;
  
  strong {
    color: #1e293b;
  }
}

.terms-list-box {
  background-color: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 16px 20px;
}

.terms-ordered-list {
  margin: 0;
  padding: 0 0 0 20px;
  
  li {
    font-size: 13px;
    line-height: 1.6;
    color: #475569;
    margin-bottom: 10px;
    
    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: #1e293b;
    }
  }
}

.terms-link {
  color: #2563eb;
  text-decoration: underline;
  font-weight: 600;
  &:hover {
    color: #1d4ed8;
  }
}

.warning-alert-text {
  font-size: 12px;
  font-weight: 600;
  color: #ef4444;
  margin: 12px 0 0 0;
}

.mb-3 { margin-bottom: 12px; }
</style>